var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "cancel-contract-modal", role: "dialog" },
      on: {
        click: function($event) {
          _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _vm.canCancelContract
            ? _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header bg-color-info" }, [
                  _c(
                    "button",
                    {
                      staticClass: "close close-btn",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function($event) {
                          _vm.$emit("close")
                        }
                      }
                    },
                    [_vm._v(" ×")]
                  )
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-cancel text-white",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function($event) {
                          _vm.$emit("confirm")
                        }
                      }
                    },
                    [_vm._v("解約する")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function($event) {
                          _vm.$emit("close")
                        }
                      }
                    },
                    [_vm._v("キャンセル")]
                  )
                ])
              ])
            : _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header bg-color-info" }, [
                  _c(
                    "button",
                    {
                      staticClass: "close close-btn",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function($event) {
                          _vm.$emit("close")
                        }
                      }
                    },
                    [_vm._v(" ×")]
                  )
                ]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function($event) {
                          _vm.$router.push(
                            "/warehouse-sc/shipping/multi-channel"
                          )
                        }
                      }
                    },
                    [
                      _vm._v("\n          在庫の返送依頼をする\n          "),
                      _c("i", {
                        staticClass: "fa fa-chevron-circle-right",
                        attrs: { "aria-hidden": "true" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function($event) {
                          _vm.$emit("close")
                        }
                      }
                    },
                    [_vm._v("キャンセル")]
                  )
                ])
              ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c("p", { staticClass: "font-bold" }, [
        _vm._v("セルモンプレミアムを解約しますか？")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flexbox gap-10" }, [
        _c("i", {
          staticClass: "fa fa-exclamation-triangle text-danger text-size-20",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "text-danger" }, [
          _vm._v(
            "\n            すべてのプレミアム限定機能がただちに利用できなくなります。\n            "
          ),
          _c("br"),
          _vm._v(
            "\n            解約の時点で機能停止となり、日割り・返金対応はございません。\n          "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "font-bold" }, [
        _vm._v("解約後は自動的にベーシックプランへ切り替わります。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c(
        "div",
        {
          staticClass: "flexbox gap-10",
          staticStyle: { "align-items": "baseline" }
        },
        [
          _c("i", {
            staticClass: "fa fa-exclamation-triangle text-danger text-size-20",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "text-danger" }, [
              _vm._v("現在、STOCKCREW倉庫に在庫があります。")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "font-bold" }, [
              _vm._v("プレミアム解約前に在庫の返送依頼をしてください")
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v("※返送の完了を待たずに、解約を進めることができます。")
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "解約後はプレミアム機能がすべて停止し、日割り・返金対応はございません。"
              )
            ])
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22f3a91e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22f3a91e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/setting/CancelContractModal.vue
// module id = null
// module chunks = 